import React from 'react';
import { ModuleBase } from '@/components';

const NoHeroModule = ({ data }) => {
  return <ModuleBase data={data} className={'h-[76px] md:h-[104px]'} />;
};

export default NoHeroModule;
